import { Youtube } from "lucide-react";
import { Link } from "react-router-dom";
import { POLICY_ORDER, POLICY_META } from "@/data/policies";
import FooterAdminLogin from "@/components/landing/FooterAdminLogin";

const Footer = () => {
  return (
    <footer
      data-testid="main-footer"
      className="relative border-t border-white/5 mt-10"
    >
      {/* marquee */}
      <div className="overflow-hidden border-y border-white/5 py-7 bg-[#0a0612]">
        <div className="marquee flex items-center gap-12 whitespace-nowrap font-display font-black text-[44px] md:text-[64px] tracking-tighter">
          {Array.from({ length: 4 }).map((_, k) => (
            <span key={k} className="flex items-center gap-12">
              <span className="text-white">SB Media Studio</span>
              <span className="text-[#00f0ff]">·</span>
              <span className="italic font-light text-[#a395c3]">
                Premium podcast production
              </span>
              <span className="text-[#ff0055]">·</span>
              <span className="text-white">Lakeland · FL</span>
              <span className="text-[#00f0ff]">·</span>
              <span className="italic font-light text-[#a395c3]">
                Press record
              </span>
              <span className="text-[#ff0055]">·</span>
            </span>
          ))}
        </div>
      </div>

      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-12 md:py-16">
        <div className="grid grid-cols-12 gap-x-5 gap-y-10 md:gap-8 items-start">
          <div className="col-span-12 md:col-span-4 min-w-0">
            <div className="flex items-center gap-3">
              <div className="relative w-11 h-11 rounded-xl bg-gradient-to-br from-[#00f0ff]/15 via-[#6b21d9]/20 to-[#ff0055]/15 border border-white/10 flex items-center justify-center overflow-hidden">
                <img
                  src="/brand/sb-logo.svg"
                  alt="SB Media Studio"
                  className="w-8 h-8 object-contain"
                  style={{ filter: "invert(1) brightness(1.15)" }}
                />
              </div>
              <div className="leading-tight">
                <div className="font-display font-black text-[15px] tracking-tight">
                  SB <span className="text-[#00f0ff]">Media</span>
                </div>
                <div className="text-[9px] uppercase tracking-[0.32em] text-[#a395c3]">
                  Studio
                </div>
              </div>
            </div>
            <p className="text-[#a395c3] text-sm mt-5">
              Premium podcast production, studio rental, headshots &amp; UGC.
              Based in Lakeland, Florida. Serving Central Florida &amp; beyond.
            </p>
          </div>

          <div className="col-span-6 md:col-span-2 min-w-0">
            <div className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-4">
              Navigate
            </div>
            <ul className="space-y-2.5 text-sm">
              {[
                ["Home", "#home"],
                ["The Studio", "#studio"],
                ["Packages", "#packages"],
                ["Spotlight", "#spotlight"],
                ["Contact", "#contact"],
                ["Client Portal", "/client-portal"],
              ].map(([l, h]) => (
                <li key={l}>
                  <a
                    href={h}
                    data-testid={`footer-link-${l.toLowerCase().replace(" ", "-")}`}
                    className="text-white/70 hover:text-[#00f0ff] transition-colors"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-6 md:col-span-3 min-w-0">
            <div className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-4">
              Legal
            </div>
            <ul className="space-y-2.5 text-sm">
              {POLICY_ORDER.map((slug) => (
                <li key={slug}>
                  <Link
                    to={`/legal/${slug}`}
                    data-testid={`footer-legal-${slug}`}
                    className="text-white/70 hover:text-[#00f0ff] transition-colors leading-snug block"
                  >
                    {POLICY_META[slug].label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="col-span-12 md:col-span-3 min-w-0">
            <div className="text-[10px] uppercase tracking-[0.32em] text-white/40 mb-4">
              Follow & subscribe
            </div>
            <div className="flex items-center gap-3 flex-wrap">
              <a
                href="https://www.youtube.com/@SB_Spotlight"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-youtube"
                aria-label="YouTube"
                className="w-11 h-11 rounded-full bg-white/[0.04] border border-white/10 flex items-center justify-center hover:bg-[#00f0ff] hover:text-[#05050a] hover:border-[#00f0ff] transition-colors"
              >
                <Youtube size={16} />
              </a>
              <a
                href="https://www.sbmediastudio.com/"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-website"
                className="px-4 h-11 rounded-full bg-white/[0.04] border border-white/10 inline-flex items-center text-xs uppercase tracking-[0.22em] text-white/80 hover:bg-white hover:text-[#05050a] transition-colors"
              >
                sbmediastudio.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-white/5 flex flex-col md:flex-row items-start md:items-center justify-between gap-3">
          <div className="text-xs text-white/40">
            © {new Date().getFullYear()} SB Media Studio · All rights reserved.
          </div>
          <div className="flex items-center gap-6">
            <FooterAdminLogin />
            <div className="font-mono-tight text-[10px] uppercase tracking-[0.32em] text-white/30">
              Cinematic landing · v1.0
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
